import tools from '@/sag-core/tools'
import Operation from '@/sag-core/base/OperationBase'

let count = 0
class GridData {

    constructor({name=`id_${count}` , columns=[], columnsConfig={}, rowsConfig={}, relationships=[], parent=null }){
        count++
        const that = this

        this.status = new Operation(name)
        
        // 識別號
        this.name = name

        // 是否需要選項欄位(修改、刪除)
        this.columnOptionEnabled = true

        // Parent
        this.parent = parent

        // init初始化時檢查
        this.isChild = false

        // 過濾後資料列(isChild使用)
        this.filterRows = []
        const filterAction = ()=>{
            that.filterRows.splice(0, that.filterRows.length)
            that.rows.filter(row=>{
                let isRela = true
                // 確認關聯性
                that.relationships.forEach(rela=>{
                    if(isRela)
                        isRela = that.parent.currentHaveColumn(rela.parentColumnName) && row[rela.parentColumnName] === that.parent.current.data[rela.parentColumnName]
                })
                return isRela
            }).forEach(row=>{
                that.filterRows.push(row)
            })
        }

        // 資料列顯示資料(與元件綁定)
        this.rows = []
        this.fillRows = (data)=>{
            if(Array.isArray(data)){
                this.rows.splice(0, this.rows.length)
                data.forEach(d=>{
                    let row = {}
                    Object.assign(row, d)
                    that.rows.push(row)
                })

                tools.debug.log({tag: 'girdData', title: '陣列資料灌入', content: `${that.name} 資料灌入`}, that, data)
            }
            else if(data instanceof Object){
                this.rows.splice(0, this.rows.length)
                for(let key in data){
                    that.rows.push({[columns[0].field]: key, [columns[1].field]: data[key]})
                }
                tools.debug.log({tag: 'girdData', title: 'dict資料灌入', content: `${that.name} 資料灌入`}, that, data)
            }
            that.eventInvoke(that.currentDataChangeEventDelay)
        }

        // 資料列配置
        this.rowsConfig = rowsConfig
        
        // 欄位顯示資料(與元件綁定)
        this.columns = columns

        // 欄位配置
        this.columnsConfig = columnsConfig

        // 目前資料
        this.current = {
            data: null,
            index: 0,
            pageIndex: 0
        }
        this.currentDataInit = ()=>{
            Object.assign(this.current, {
                data: null,
                index: 0,
                pageIndex: 0
            })
        }
        this.currentHaveColumn = (column)=>{
            return this.current && this.current.data && column in this.current.data
        }

        // 關聯性
        this.relationships = relationships

        // 關聯事件(parent在查詢時觸發)
        this.queryRelationEvents = []

        // 關聯事件(parent在刪除時觸發)
        this.deleteRelationEvents = []

        // rows資料改變事件
        this.dataChangeEvent = {}

        // 目前資料(光標)改變時觸發事件(刪除、修改、點擊)
        this.currentDataChangeEvent = {}
        this.currentDataChangeEventDelay = []

        

        // Query
        this._getData = function(){throw 'no regist api getData'}
        Object.defineProperty(this, 'getData', {
                get: function(){ return that._getData },
                set: function(func){ that._getData = (args)=>
                {
                    return new Promise((ok, no)=>{
                        func(args).then((res)=>{
                            that.queryRelationEvents.forEach(relationEvent=>{
                                relationEvent()
                            })
                            for(let event in that.dataChangeEvent){
                                that.dataChangeEvent[event](that.rows)
                            }
                            that.status.setLoaded()
                            ok(res)
                        })
                    })
                } 
            }}
        )

        // Insert
        this._insertData = function(){throw 'no regist api insertData'}
        Object.defineProperty(this, 'insertData', {
                get: function(){ return that._insertData },
                set: function(func){ that._insertData = (args)=>
                {
                    return new Promise((ok, no)=>{
                        func(args).then((res)=>{
                            for(let event in that.dataChangeEvent){
                                that.dataChangeEvent[event](that.rows)
                            }
                            that.status.setLoaded()
                            ok(res)
                        })
                    })
                } 
            }}
        )

        // Delete
        this.deleteData = function(){throw 'no regist api deleteData'}
        Object.defineProperty(this, 'deleteData', {
                get: function(){ return that._deleteData },
                set: function(func){ that._deleteData = (args)=>
                {
                    if(!Array.isArray(args))
                        args = [args]
                    return new Promise((ok, no)=>{
                        func(args).then((res)=>{
                            that.deleteRelationEvents.forEach(relationEvent=>{
                                relationEvent(args)
                            })
                            for(let event in that.dataChangeEvent){
                                that.dataChangeEvent[event](that.rows)
                            }

                            that.status.setLoaded()
                            ok(res)
                        })
                    })
                } 
            }}
        )

        // Update
        this.updateData = function(){throw 'no regist api updateData'}
        Object.defineProperty(this, 'updateData', {
                get: function(){ return this._updateData },
                set: function(func){ that._updateData = (args)=>
                {
                    return new Promise((ok, no)=>{
                        func(args).then((res)=>{
                            for(let event in that.dataChangeEvent){
                                that.dataChangeEvent[event](that.rows)
                            }
                            that.status.setLoaded()
                            ok(res)
                        })
                    })
                } 
            }}
        )

        // 刪除關聯性註冊
        this._deleteRelationshipRegist = ()=>{
            if(that.isChild && that.parent){
                that.parent.deleteRelationEvents.push((parentDeleteDatas)=>{
                    tools.debug.log({tag: 'eventsOccur', title: '事件發生順序查詢', content: `deleteRelationEvent 觸發者: ${that.parent.name}, parent rows len: ${that.parent.rows.length}, child rows len: ${that.rows.length}`}, that.name, that)
                    const childDeleteDatas = []
                    for(let i = 0; i < that.rows.length; i++){
                        for(let j = 0; j < parentDeleteDatas.length; j++){
                            const parentDeleteData = parentDeleteDatas[j]
                            let rela = true
                            for(let k = 0; k < that.relationships.length; k++){
                                const { parentColumnName } = that.relationships[k]
                                if(!(parentColumnName in that.rows[i]) || !(parentColumnName in parentDeleteData)){
                                    tools.debug.log({tag: 'error', title: '錯誤發生', content: `刪除關聯性尋找子欄位名稱時錯誤, that.rows, that.relationships, parentDeleteDatas`}, that.rows, that.relationships, parentDeleteDatas)
                                }
                                if(parentDeleteData[parentColumnName] !== that.rows[i][parentColumnName]){
                                    rela = false
                                    break
                                }
                            }
                            if(rela){
                                childDeleteDatas.push(that.rows[i])
                                break
                            }
                        }
                    }
                    
                    for(let i = 0; i < that.rows.length; i++){
                        for(let j = 0; j < childDeleteDatas.length; j++){
                            if(tools.isSameObject(that.rows[i], childDeleteDatas[j])){
                                that.rows.splice(i, 1)
                                break
                            }
                        }
                    }
                    
                    that.deleteData(childDeleteDatas)
                    filterAction()
                })
            }
        }

        // 查詢關聯性註冊
        this._queryRelationshipRegist = ()=>{
            if(that.isChild && that.parent){
                that.parent.queryRelationEvents.push(()=>{
                    tools.debug.log({tag: 'eventsOccur', title: '事件發生順序查詢', content: `queryRelationEvents 觸發者: ${that.parent.name}, parent rows len: ${that.parent.rows.length}, child rows len: ${that.rows.length}`}, that.name, that)
                    const sqlSugarQueryKeys = []
                    for(let i = 0; i < that.parent.rows.length; i++){
                        const Keys = []
                        const row = that.parent.rows[i]
                        for(let j = 0; j < that.relationships.length; j++){
                            const columnName = that.relationships[j].parentColumnName
                            Keys.push({
                                FieldName: columnName,
                                ConditionType: 0,
                                FieldValue: row[columnName]
                            })
                        }
                        sqlSugarQueryKeys.push({
                            Keys: Keys
                        })
                    }

                    if(sqlSugarQueryKeys.length){
                        that.getData(sqlSugarQueryKeys)
                    }
                    else{
                        that.rows.splice(0, that.rows.length)
                    }
                })
            }
        }

        // 光標事件註冊
        this._currentCursorRegist = ()=>{
            if(that.isChild){
                that.parent.currentDataChangeEvent[that.name + '/currentCursorFilter'] = ()=>{

                    if(that.status.isQuery()){
                        tools.debug.log({tag: 'eventsOccur', title: '事件發生順序查詢', content: `${that.name} status is ${that.status.nowOp()}, currentDataChangeEventDelay add`}, that.currentDataChangeEventDelay)
                        that.currentDataChangeEventDelay.push(filterAction)
                        return
                    }

                    filterAction()
                }
            }
        }

        this.init()
    }

    // 初始化
    init(){
        // isChild檢查
        if(this.parent instanceof GridData){
            // 關聯欄位是否都正確(存在)
            let relaCorrect = true            
            for(let i = 0; i < this.relationships.length; i++){
                
                const { parentColumnName } = this.relationships[i]
                
                const tmpMap = Object.assign([], this.parent.columns)
                
                for(let j = 0; j < tmpMap.length; j++){
                    const { field } = tmpMap[j]
                    if(field === parentColumnName){
                        tmpMap.splice(j, 1)
                        break
                    }

                    if(j === tmpMap.length - 1){
                        relaCorrect = false
                    }
                }

                if(!relaCorrect){
                    throw `gridData ${this.name} relationship設置錯誤`
                }
            }
            this.isChild = true
        }

        // columns config附加上columns
        this.columns.forEach(e=>{
            if(e.field !== 'action'){

                for(let key in this.columnsConfig){
                    if(!(key in e)){
                        let obj = JSON.parse(JSON.stringify(this.columnsConfig[key]))
                        e[key] = obj
                    }
                }
            }
            else{
                e['tdClass'] = this.columnsConfig['tdClass']
            }
        })

        this._currentCursorRegist()
        this._queryRelationshipRegist()
        this._deleteRelationshipRegist()
    }

    eventInvoke(events){
            if(Array.isArray(events)){
                events.forEach(e=>{
                    e()
                })
            }
            else{
                for(let key in events){
                    if(typeof(events[key]) === 'function')
                        events[key]()
                }
            }
    }

    eventClear(events){
        if(Array.isArray(events)){
            events.splice(0, events.length)
        }
        else{
            for(let key in events){
                delete events[key]
            }
        }
    }
}

export default GridData